// src/constants/reviewFormText.js
export const reviewFormText = {
    title: '🌟 Leave a Review',
    namePlaceholder: 'Your Name (optional)',
    messagePlaceholder: 'Tell us about your experience...',
    submitButton: '✅ Submit Review',
    successMessage: '✅ Thank you for your feedback!',
    errorMessage: '❌ Something went wrong. Try again.'
  };